import { ModelBase } from './model-base';
import { NutritionHelper } from './nutrition-helper';

export class NutritionValues extends ModelBase {

  kj: number;
  kcal: number;
  protein: number;
  carbohydrate: number;
  carbohydrateOfWhichSugars: number;
  fat: number;
  fatOfWhichSaturates: number;
  fibre: number;
  sodium: number;
  salt: number;

  //referenceIntakeProfile: NutritionHelper;
  constructor(s?: any) {
    super(s);
    if (s) {
      this.salt = this.getSaltFromSodium(this.sodium);
    }
    //use system default as defined in hardcoded class from old version of FP
    //this.referenceIntakeProfile = new NutritionHelper();
  }

  private getSaltFromSodium(sodium: number) {
    return +((sodium * 2.5) / 1000).toFixed(2);
  }

  //public getNutritionPercentage(field: string) {
  //  if (!field || !this[field]) {
  //    return 0;
  //  }
  //  if (field === 'kj' || field === 'kcal') {
  //    const kJPercentage = this.kj / this.referenceIntakeProfile.kj;
  //    const kcalPercentage = this.kcal / this.referenceIntakeProfile.kcal;
  //    return (((kJPercentage + kcalPercentage) / 2) * 100).toFixed(0);
  //  } else {
  //    return +((this[field] / this.referenceIntakeProfile[field]) * 100).toFixed(0);
  //  }
  //}

  public getNutritionColorCoding(field: string, recipePortionSize: number) {
    if (!field || !this[field] || !recipePortionSize) {
      return 'low';
    }
    if (this[field] > NutritionHelper.colorCodingData[field].maxPerPortion) {
      return 'high';
    }

    const per100Gramm = (this[field] / recipePortionSize) * 100;

    if (per100Gramm <= NutritionHelper.colorCodingData[field].maxLow) {
      return 'low';
    }
    if (per100Gramm <= NutritionHelper.colorCodingData[field].maxMedium) {
      return 'medium';
    }
    return 'high';
  }
}

